export default function QuickStartHeader() {
  return (
    <div className="font-inter font-bold text-16 leading-19 w-1080px">
      Welcome to the timePhasing quick start guide.
    </div>
  );
}